import { useCallback } from 'react';

import { useReactNativeWebView } from 'src/shared/hooks';
import { MobileAppActionEnum } from 'src/shared/hooks/useReactNativeWebView/types';

type LinkOpener = (url: string) => void;

const useLinkOpener = (): LinkOpener => {
  const [isWebView, sendReactNativeMessage] = useReactNativeWebView();

  const linkOpener = useCallback(
    (url: string) => {
      if (isWebView) {
        // For in-app usage, this link should be opened in the
        // browser application, not in the existing webview for Desgin Studio.
        sendReactNativeMessage(
          JSON.stringify({
            action: MobileAppActionEnum.OPEN_LINK,
            data: url,
          }),
        );
      } else {
        window.open(url, '_blank', 'noreferrer');
      }
    },
    [isWebView, sendReactNativeMessage],
  );

  return linkOpener;
};

export { useLinkOpener };
